document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-media-target]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const section = thumb.closest('[data-product-section]');
      section.querySelectorAll('.product-media').forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === thumb.dataset.mediaTarget));
      section.querySelectorAll('[data-media-target]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addButton = section.querySelector('[data-add-button]');
    const price = section.querySelector('[data-product-price]');
    if (select) select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      variantInput.value = option.value;
      addButton.disabled = !available;
      addButton.childNodes[0].nodeValue = available ? 'ADD TO BAG ' : 'SOLD OUT ';
      price.innerHTML = option.dataset.compare && option.dataset.compare !== option.dataset.price ? `<s>${option.dataset.compare}</s><span>${option.dataset.price}</span>` : `<span>${option.dataset.price}</span>`;
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${option.value}`);
    });
    const qty = section.querySelector('.quantity-field input');
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value) - 1); });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.value = Number(qty.value) + 1; });
  });
});
